<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="list-of-illustrations">
<div class="section level2" id="the-creation">
<p style="text-align: center; padding-top:120px;"><img alt="" src="media/file0.png" style="width:3.39583in;height:4.82222in"/></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?2683ca76